import { memo, useCallback, useId, useMemo } from "react"

import Checkbox from "components/Checkbox/Checkbox"

import { CheckbokItemProps } from "./types"

export const CheckbokItem = memo(({ item, selectedItems, onChange }: CheckbokItemProps) => {
    const uniqueId = useId()
    const isSelected = useMemo(() => selectedItems.includes(item.value), [selectedItems, item.value])

    const handleChange = useCallback(() => {
        onChange(item.value)
    }, [onChange, item.value])

    return (
        <div className="flex items-center gap-2 hover:bg-base-muted p-1 rounded-md transition-colors">
            <Checkbox
                id={uniqueId}
                className="[&[data-state=checked]]:bg-indigo-500 [&[data-state=indeterminate]]:bg-indigo-500"
                label={item.label}
                value={item.value}
                checked={isSelected}
                onCheckedChange={handleChange}
            />
        </div>
    )
})